import { render, staticRenderFns } from "./car-insurance-vehicle-form.html?vue&type=template&id=822470e4&scoped=true&"
import script from "./car-insurance-vehicle-form.js?vue&type=script&lang=js&"
export * from "./car-insurance-vehicle-form.js?vue&type=script&lang=js&"
import style0 from "./car-insurance-vehicle-form.scss?vue&type=style&index=0&id=822470e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822470e4",
  null
  
)

export default component.exports